import type { MarketingPreferencesVerticalState, MarketingPreferencesFormState } from './types';

export const MARKETING_PREFERENCES_FORM_VARIANT = {
  BINGO: 'BINGO',
  CASINO: 'CASINO'
} as const;

export const MARKETING_PREFERENCES_FORM_VALUES: MarketingPreferencesVerticalState = {
  email: false,
  phoneCall: false,
  sms: false,
  post: false
};

export const INITIAL_MARKETING_PREFERENCES_FORM_STATE: MarketingPreferencesFormState = {
  receiveAll: false,
  BINGO: MARKETING_PREFERENCES_FORM_VALUES,
  CASINO: MARKETING_PREFERENCES_FORM_VALUES
};
